import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import * as serviceWorker from "./serviceWorker";
import Login from "./Login";
import NoToken from "./NoToken";

ReactDOM.render(
  <BrowserRouter basename="/">
    <Switch>
      <Route exact component={NoToken} path="/noToken" />
      <Route
        render={(match) => <Login {...match} />}
        path="/token/:tokenCode"
      />
      <Route component={Login} path="*" />
      <NoToken />
    </Switch>
  </BrowserRouter>,
  document.getElementById("root")
);

// If you want your Login to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
